import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMetadataListItem } from '@app/@shared/models/reverse-engineering/analysis.models';

@Component({
    selector: 'app-sidebar-flat-list-metadata-content',
    templateUrl: './sidebar-flat-list-metadata-content.component.html',
    styleUrls: ['./sidebar-flat-list-metadata-content.component.scss'],
    standalone: false
})
export class SidebarFlatListMetadataContentComponent  {

  @Input() metadataList: Array<IMetadataListItem>;

  @Output() metaDataItemClicked: EventEmitter<string> = new EventEmitter<string>();

  onMetaDataItemClick(metadataKey: string){
    this.metaDataItemClicked.emit(metadataKey);
  }

}